var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((5),function(i){return _c('v-icon',{key:i,class:_vm.readonly ? 'no-cursor' : 'hover',attrs:{"color":_vm.color},on:{"click":function($event){return _vm.onClick($event, i)}}},[_vm._v(_vm._s(_vm.icon(i)))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }